module.exports = __webpack_public_path__ + "img/culture_img3.75e031a8.png";